<template>
	<div>
		<ScheduleBanner />
		<div class="content-zsy">
			<div class="title-wrap">
			    <h3>배송일정</h3>
			</div>
			<h5 class="schedule-title">웨이하이 <span>해상 스케쥴</span></h5>
			 <el-table
			      :data="sea_freight"
			      style="width: 100%;">
			      <el-table-column
			        prop="data1"
			        label="출고요일"
			        >
			      </el-table-column>
			      <el-table-column
			        prop="data2"
			        label="결제마감 / 출고"
			        >
			      </el-table-column>
			      <el-table-column
			        prop="data3"
			        label="출발">
			      </el-table-column>
				  <el-table-column
				    prop="data4"
				    label="한국도착 / 통관">
				  </el-table-column>
			    </el-table>
				<p class="schedule-desc frontground-color">
					* 해상의 경우 인천세관 도착 이후 통관물량에 따라 평균 2~5일 후 택배인계 됩니다.<br>
					홈페이지에서 금일 통관 상황을 참고하여 주시기 바랍니다.
				</p>
				
				<h5 class="schedule-title">웨이하이 <span>항공 스케쥴</span></h5>
				<el-table
				 :data="air_freight"
				 style="width: 100%">
				 <el-table-column
				   prop="data1"
				   label="출고요일"
				   >
				 </el-table-column>
				 <el-table-column
				   prop="data2"
				   label="결제마감 / 출고"
				   >
				 </el-table-column>
				 <el-table-column
				   prop="data3"
				   label="출발">
				 </el-table-column>
				  <el-table-column
					prop="data4"
					label="한국도착 / 통관">
				  </el-table-column>
			   </el-table>
			   <p class="schedule-desc frontground-color">
				   * 항공사는 선적 스페이스 확보에 따라 탄력적으로 선택 운영합니다.<br>
				   경우에 따라 선적 항공사가 변경될 수 있으며 출발, 도착시간이 변경될 수 있습니다.<br>
				   항공의 경우 세관 도착 후 평균 1~2일 후 택배인계 됩니다.
			   </p>
			   
				<h5 class="schedule-title">웨이하이 <span>LCL 운송 스케쥴</span></h5>
				<el-table
					 :data="lcl_freight"
					 style="width: 100%">
					 <el-table-column
					   prop="data1"
					   label="결제마감"
					   >
					 </el-table-column>
					 <el-table-column
					   prop="data2"
					   label="출발"
					   >
					 </el-table-column>
					 <el-table-column
					   prop="data3"
					   label="한국도착 / 통관">
					 </el-table-column>
				</el-table>
			
				<div class="common-wrap">
					<h6>공통사항</h6>
					<p class="" >배송일정은 천재지변, 결항, 항공사, 선사, 항만, 공항, 해당국 세관의 사정에 따라 달라질 수 있습니다.</p>
				</div>
			
		</div>
		
		
		
	</div>
</template>

<script>
	import ScheduleBanner from '../../components/ScheduleBanner.vue'
	export default {
		components: {
			ScheduleBanner
		},
		data() {
			return{
				 sea_freight: [{
					data1: '월',
					data2: '11:00',
					data3: '월요일 18:00',
					data4: '화요일 12:00 ~'
				  }, {
					data1: '화',
					data2: '11:00',
					data3: '화요일 18:00',
					data4: '수요일 12:00 ~'
				  }, {
					data1: '수',
					data2: '11:00',
					data3: '수요일 18:00',
					data4: '목요일 12:00 ~'
				  }, {
					data1: '목',
					data2: '11:00',
					data3: '목요일 18:00',
					data4: '금요일 12:00 ~'
				  }, {
					data1: '금',
					data2: '11:00',
					data3: '금요일 18:00',
					data4: '토요일 12:00 ~'
				  }, {
					data1: '일',
					data2: '11:00',
					data3: '일요일 18:00	',
					data4: '월요일 12:00 ~'
				  }],
				  air_freight:[{
					data1: '월',
					data2: '11:00',
					data3: '화요일',
					data4: '화요일 15:00 ~'
				  }, {
					data1: '화',
					data2: '11:00',
					data3: '수요일',
					data4: '수요일 15:00 ~'
				  }, {
					data1: '수',
					data2: '11:00',
					data3: '목요일',
					data4: '목요일 15:00 ~'
				  }, {
					data1: '목',
					data2: '11:00',
					data3: '금요일',
					data4: '금요일 15:00 ~'
				  }, {
					data1: '금',
					data2: '11:00',
					data3: '토요일',
					data4: '토요일 15:00 ~'
				  }, {
					data1: '일',
					data2: '11:00',
					data3: '월요일',
					data4: '월요일 15:00 ~'
				  }],
				  lcl_freight:[{
					data1: '화요일 11:00',
					data2: '수요일 18:00 출발',
					data3: '목요일 15:00 도착',
				  }, {
					data1: '목요일 11:00',
					data2: '금요일 18:00 출발',
					data3: '토요일 15:00 도착',

				  }, {
					data1: '일요일 11:00',
					data2: '월요일 18:00 출발',
					data3: '화요일 15:00 도착',

				  }],
				  
			}
		},
	
		methods: {
	
		}
	
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 30px;
	}
	.title-wrap h3 {
	    font-size: 45px;
		font-weight: bold;
		color: var(--frontground-color);
		letter-spacing: -0.025em;
	}
	.schedule-title {
		padding:30px 0 0;
	    font-size: 24px;
	    font-weight: bold;
	    margin-bottom: 19px;
	}
	.schedule-title span {
	    color: var(--main-color);
	}
	.schedule-desc {
		padding-top: 10px;
	    line-height: 30px;
	    color: rgba(0, 0, 0, 0.8);
	}
	.common-wrap {
	    margin-top: 102px;
	}
	.common-wrap h6 {
	    font-size: 24px;
	    font-weight: bold;
	    margin-bottom: 19px;
	}
	.common-wrap p {
	    font-size: 17px;
	    color: var(--frontground-color);
	}
	.cell{
		color:#000;
	}
	
	.el-table thead {
	    color: #000;
	    font-weight: bold;
	}
	.frontground-color{
		color:var(--frontground-color);
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:0 10px;
		}
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.common-wrap {
		    margin-bottom: 40px;
		}
	}
</style>